module.exports = __webpack_public_path__ + "static/media/android-4.454f83cc.jpg";